import { reactive } from '@nuxtjs/composition-api';

export default function useConfirmationInfo () {
  const confirmation = reactive({
    accepted: false
  })
  return {
    confirmation
  }
}
